import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TCOLanguages } from './core/models/i18n.model';
import { PageStateService } from './core/services/common/page-state.service';
import { CalAngularService } from '@cvx/cal-angular';
import { TokenValidationService } from './core/services/auth/tokenValidation';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  showNavbar: boolean = !window.location.href.includes('flowmeter');
  currentPage: string = '';
  loggedIn: boolean = false;

  constructor(
    private _router: Router,
    private _translate: TranslateService,
    private pageStateService: PageStateService,
    private calAuthService: CalAngularService,
    private tokenValidationService: TokenValidationService
  ) {
    // this language will be used as a fallback when a translation isn't found in the current language
    _translate.setDefaultLang(TCOLanguages.RU);
    _translate.addLangs([TCOLanguages.EN, TCOLanguages.RU, TCOLanguages.KZ]);

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    _translate.use(TCOLanguages.RU);
    this.pageStateService.getPageState().subscribe((page) => {
      this.currentPage = page;
    });
  }

  ngOnInit(): void {
    // Subscribe to authentication state
    this.calAuthService.isUserSignedIn().subscribe((isSignedIn: boolean) => {
      if (isSignedIn) {
        const user = this.calAuthService.cvxClaimsPrincipal;
        console.log('currentUserProfile', user);
        localStorage.setItem('currentUser', JSON.stringify(user));
        this.tokenValidationService.startTokenValidation();
      } else {
        localStorage.removeItem('currentUser');
      }
    });
  }

  isMainPage(): boolean {
    return [
      '/',
      '/TCO',
      '/TCO/ProcessEng',
      '/FD',
      '/TCO/ProcessEng/FD/KTL/MonthlyReport',
      '/TCO/ProcessEng/FD/KTL/cc',
      '/TCO/ProcessEng/FD/KTL/Schema',
      '/TCO/ProcessEng/FD/SGP/DailyReport',
      '/TCO/ProcessEng/FD/SGP/MonthlyReport',
      '/TCO/ProcessEng/FD/SGP/cc',
      '/TCO/ProcessEng/FD/SGP/Schema',
      '/TCO/ProcessEng/FD/SGI/flare-report',
      '/TCO/ProcessEng/FD/SGI/target-permit',
      '/TCO/ProcessEng/FD/SGI/cc',
      '/TCO/ProcessEng/FD/LPG/FuelGasFlaring',
      '/TCO/ProcessEng/FD/LPG/CC',
      '/TCO/ProcessEng/FD/LPG/Input/PE/flowmetercalc',
      '/TCO/ProcessEng/FD/KTLSGP/So2Emissions/MonthlyReport',
      '/TCO/ProcessEng/FD/3GP/DailyReport',
      '/TCO/ProcessEng/FD/3GP/MonthlyReport',
      '/TCO/ProcessEng/FGD/KTL/Input',
      '/TCO/ProcessEng/FGD/KTL/ProductionGasBalance',
      '/TCO/ProcessEng/FGD/KTL/monthly-report',
      '/TCO/ProcessEng/FGD/SGP/DailyReport',
      '/TCO/ProcessEng/FGD/SGP/MonthlyReport',
      '/TCO/ProcessEng/FGD/SGP/GasUsageReport',
      '/TCO/ProcessEng/FGD/3GP/GUR',
      '/TCO/ProcessEng/FGD/3GP/CC',
      '/TCO/ProcessEng/DataRecovery/KTL/monthly-report',
      '/TCO/ProcessEng/DataRecovery/KTL/daily-report',
      '/TCO/ProcessEng/FD/3GP/CC',
      '/TCO/ProcessEng/FD/3GI/DailyReport',
      '/TCO/ProcessEng/FD/3GI/MonthlyReport',
      '/TCO/ProcessEng/FD/3GI/CC',
      '/not-authorized',
    ].includes(this.currentPage);
  }
}
